import UniversalChart from '../../../components/containers/reportChartController';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import Cookies from 'js-cookie';
import './laneviewHeatmap.css';
import React from 'react';

const LaneviewHeatmap = () => {
  const chartObject = {
    customerName: Cookies.get('cp-cn'),
    reportName: 'laneviewheatmap',
    reportId: '12',
    defaultFilterOptions: { 'key': 'AVERAGE TRANSIT DAYS', 'Origin State': 'UTAH'}
  };

  return (
    <div className="LandingPage">
      <div className="LandingPageContainer">
        <NavBar/>
        <Sidebar/>
        <div className="formTrackerPageContent">
          <UniversalChart request={chartObject}/>
        </div>
      </div>
    </div>
  )
}

export default LaneviewHeatmap